import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Divider
} from '@material-ui/core';
import {
  Share as ShareIcon,
  AddBox as AddBoxIcon,
  Check as CheckIcon
} from '@material-ui/icons';
import { i18n } from '../translate/i18n';

const IOSInstallInstructionsDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h6" component="div" style={{ fontWeight: 600 }}>
            {i18n.t('pwa.ios.title')}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="textSecondary" paragraph align="center">
          {i18n.t('pwa.ios.subtitle')}
        </Typography>

        <Divider style={{ margin: '16px 0' }} />

        <List>
          <ListItem>
            <ListItemIcon>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={40}
                height={40}
                borderRadius="50%"
                bgcolor="primary.main"
                color="white"
                fontWeight="bold"
              >
                1
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  {i18n.t('pwa.ios.step1.title')}
                </Typography>
              }
              secondary={
                <Box display="flex" alignItems="center" mt={1}>
                  <ShareIcon fontSize="small" style={{ marginRight: 8 }} />
                  <Typography variant="body2" color="textSecondary">
                    {i18n.t('pwa.ios.step1.description')}
                  </Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={40}
                height={40}
                borderRadius="50%"
                bgcolor="primary.main"
                color="white"
                fontWeight="bold"
              >
                2
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  {i18n.t('pwa.ios.step2.title')}
                </Typography>
              }
              secondary={
                <Box display="flex" alignItems="center" mt={1}>
                  <AddBoxIcon fontSize="small" style={{ marginRight: 8 }} />
                  <Typography variant="body2" color="textSecondary">
                    {i18n.t('pwa.ios.step2.description')}
                  </Typography>
                </Box>
              }
            />
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={40}
                height={40}
                borderRadius="50%"
                bgcolor="success.main"
                color="white"
                fontWeight="bold"
              >
                <CheckIcon />
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="subtitle1" style={{ fontWeight: 500, color: 'green' }}>
                  {i18n.t('pwa.ios.step3.title')}
                </Typography>
              }
              secondary={
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
                  {i18n.t('pwa.ios.step3.description')}
                </Typography>
              }
            />
          </ListItem>
        </List>

        <Box mt={2} p={2} bgcolor="grey.100" borderRadius={2}>
          <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
            <span role="img" aria-label="info">ℹ️</span> {i18n.t('pwa.ios.note')}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          {i18n.t('common.understood')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IOSInstallInstructionsDialog;
